/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { Permission } from "@octopusdeploy/octopus-server-client";
import type { NewLibraryVariableSetResource } from "@octopusdeploy/octopus-server-client";
import * as React from "react";
import { repository } from "~/clientInstance";
import { ActionButtonType } from "~/components/Button/ActionButton";
import type { DataBaseComponentState } from "~/components/DataBaseComponent/DataBaseComponent";
import { DataBaseComponent } from "~/components/DataBaseComponent/DataBaseComponent";
import OpenDialogButton from "~/components/Dialog/OpenDialogButton";
import SaveDialogLayout from "~/components/DialogLayout/SaveDialogLayout";
import MarkdownEditor from "~/components/form/MarkdownEditor/MarkdownEditor";
import { required } from "~/components/form/Validators";
import Text from "~/primitiveComponents/form/Text/Text";
import InternalRedirect from "../../../../components/Navigation/InternalRedirect/InternalRedirect";
import routeLinks from "../../../../routeLinks";
interface AddVariableSetDialogContentState extends DataBaseComponentState {
    name: string;
    description: string;
    newVariableSetId?: string;
}
class AddVariableSetButtonDialogContent extends DataBaseComponent<{}, AddVariableSetDialogContentState> {
    constructor(props: {}) {
        super(props);
        this.state = {
            name: "",
            description: "",
        };
    }
    render() {
        return (<SaveDialogLayout title="Add New Variable Set" busy={this.state.busy} errors={this.errors} onSaveClick={() => this.save()}>
                {this.state.newVariableSetId && <InternalRedirect to={routeLinks.library.variableSet(this.state.newVariableSetId)}/>}
                <Text label="New variable set name" value={this.state.name} onChange={(name) => this.setState({ name })} validate={required("Please enter a variable set name")} autoFocus={true}/>
                <MarkdownEditor label="Variable set description" value={this.state.description} onChange={(description) => this.setState({ description })} restrictHeight={true}/>
            </SaveDialogLayout>);
    }
    private async save() {
        return this.doBusyTask(async () => {
            const libraryVariableSet: NewLibraryVariableSetResource = {
                Name: this.state.name,
                Description: this.state.description,
                VariableSetId: undefined!,
                ContentType: undefined!,
                Templates: undefined!,
                Id: undefined!,
                Links: undefined!,
            };
            const savedLibraryVariableSet = await repository.LibraryVariableSets.create(libraryVariableSet);
            this.setState({ newVariableSetId: savedLibraryVariableSet.Id });
        });
    }
    static displayName = "AddVariableSetButtonDialogContent";
}
const AddVariableSetButton: React.SFC = () => {
    return (<OpenDialogButton type={ActionButtonType.Primary} permission={{ permission: Permission.LibraryVariableSetCreate }} label="Add new variable set">
            <AddVariableSetButtonDialogContent />
        </OpenDialogButton>);
};
AddVariableSetButton.displayName = "AddVariableSetButton"
export default AddVariableSetButton;
